import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
});

export function authApi(token) {
  return axios.create({
    baseURL: `${BACKEND_URL}/api`,
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function getImageUrl(url) {
  if (!url) return "";
  if (url.startsWith("/api")) return `${BACKEND_URL}${url}`;
  return url;
}

export const ANNOUNCEMENT = "Spedizione gratuita da €99";
